import React, { createContext } from "react";

const ToastContext: any = createContext<any>(null);

export default ToastContext;